import ObjectArrayView from '../../generic/container/ObjectArrayView';
import ObjectsByName from '../../generic/container/ObjectsByName';
import PolyMap from '../model/PolyMap';
import PolyMesh from '../model/PolyMesh';

const isVec3NaN = function (v) {
  return isNaN(v.x) || isNaN(v.y) || isNaN(v.z);
};

const isVec3Zero = function (v) {
  return v.length() === 0;
};

const isVec2NaN = function (v) {
  return isNaN(v.x) || isNaN(v.y);
};

const validateValues = function (polyMapName, values, validationFunc) {
  //console.log( polyMapName, values.length );
  const temp = new (values.type)();
  const replacement = new (values.type)();
  for (let i = 0; i < values.length; i++) {
    values.getAt(i, temp);
    if (!validationFunc(temp)) {
      //console.log( "  badValue at " + i + " is ", temp );
      values.setAt(i, replacement);
    }
  }
};

export default function polyMeshValidation(mesh) {

  validateValues('positions', mesh.positions.values, function (v) { return !isVec3NaN(v); });

  if (mesh.normalMap) {
    validateValues('normalMap', mesh.normalMap.values, function (v) { return !isVec3NaN(v) && !isVec3Zero(v); });
  }

  if (mesh.uvMaps) {
    const uvMaps = new ObjectsByName();
    for (let i = 0; i < mesh.uvMaps.length; i++) {
      let name = mesh.uvMaps.namesByIndex[i];
      validateValues('uvMap[' + name + ']', mesh.uvMaps.byName[name].values, function (v) { return !isVec2NaN(v); });
    }
  }

  return mesh;
};




// WEBPACK FOOTER //
// ./src/polyMesh/geometric/operator/polyMeshValidation.js